
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import { UsCoV1 } from '@iabtcf/gpp/encoder/section/UsCoV1.js'; 

import { updateCMPColorado } from './updateCMPFuncs.js'

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})

export default class LayerStateColorado extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsCoV1.NAME
  sectionID = UsCoV1.ID
  dirty = false

  sensitiveLeadText = "Consent to Processing of Sensitive Data Consisting of:";
  sensitiveFeatures = [
        { position: 1, description: "Personal Data Revealing Racial or Ethnic Origin." },
        { position: 2, description: "Personal Data Revealing Religious Beliefs." },
        { position: 3, description: "Personal Data Revealing a Mental or Physical Health Condition or Diagnosis." },
        { position: 4, description: "Personal Data Revealing Sex Life or Sexual Orientation." },
        { position: 5, description: "Personal Data Revealing Citizenship or Immigration Status." },
        { position: 6, description: "Genetic Data that May Be Processed for the Purpose of Uniquely Identifying an Individual." },
        { position: 7, description: "Biometric Data that May Be Processed for the Purpose of Uniquely Identifying an Individual." },
        ];

	mounted(): void {
    console.log("Colorado Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( UsCoV1.NAME ) ) {
          this.consentToSharing = this.cmpApi.getFieldValue(UsCoV1.NAME, 'SaleOptOut' ) == 2  ? true : false;
          this.consentToTargeting = this.cmpApi.getFieldValue(UsCoV1.NAME, 'TargetedAdvertisingOptOut') == 2  ? true : false;
        }
      else  {
        updateCMPColorado( true, this.cmpApi, this.consentToSharing )
      }
	}

  sensitiveDataChange( consentArray: any ) {
    console.log("LayerStateColorado: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  } 


  @Emit('changeViewEvent')
	saveSettingsClick( consentToAll : Boolean ): string {

    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }
    
    updateCMPColorado( consentToAll, this.cmpApi, this.consentToSharing );
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
